import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import ChinaTracking from "@/pages/ChinaTracking";
import { PendingArrivalSection, PendingCheckSection, CheckedSection } from "@/pages/WarehouseArrivals";
import { Package, Truck, Warehouse, ClipboardList, CheckCircle2 } from "lucide-react";

// Merged Transit + Arrival lifecycle. One page, five stages.
const STAGES = [
  { k: "placed", label: "Order Placed", icon: Package, perm: "transit:view", testid: "inbound-tab-placed" },
  { k: "shipped", label: "Shipped", icon: Truck, perm: "transit:view", testid: "inbound-tab-shipped" },
  { k: "delivered", label: "Delivered to Warehouse", icon: Warehouse, perm: "arrival:pending_view", testid: "inbound-tab-delivered" },
  { k: "pending_check", label: "Pending Check", icon: ClipboardList, perm: "arrival:check_view", testid: "inbound-tab-pending-check" },
  { k: "checked", label: "Checked", icon: CheckCircle2, perm: "arrival:checked_view", testid: "inbound-tab-checked" },
];

export default function Inbound() {
  const { can } = useAuth();
  const [sp] = useSearchParams();
  const inboundQuery = sp.get("q") || "";
  const tabs = STAGES.filter(s => can(s.perm));
  const [stage, setStage] = useState(() => {
    const saved = localStorage.getItem("inbound-stage");
    return tabs.find(t => t.k === saved) ? saved : (tabs[0]?.k || "placed");
  });
  const active = tabs.find(t => t.k === stage) ? stage : (tabs[0]?.k);
  const go = (k) => { setStage(k); localStorage.setItem("inbound-stage", k); };

  return (
    <div data-testid="inbound-page">
      <header className="mb-4">
        <div className="caption">Inbound Lifecycle</div>
        <h1 className="font-heading text-3xl font-extrabold mt-1">Inbound Management</h1>
        <p className="text-slate-500 mt-1 text-sm">
          One flow from China order to Malaysia rack — placement → shipped → delivered to warehouse → pending check → checked.
        </p>
      </header>

      <div className="flex gap-1 mb-4 border-b border-slate-200 overflow-x-auto">
        {tabs.map(t => {
          const Icon = t.icon;
          return (
            <button key={t.k} data-testid={t.testid} onClick={() => go(t.k)}
              className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition inline-flex items-center gap-2 whitespace-nowrap shrink-0 ${
                active === t.k ? "border-slate-900 text-slate-900" : "border-transparent text-slate-500 hover:text-slate-700"
              }`}>
              <Icon className="w-4 h-4" />{t.label}
            </button>
          );
        })}
      </div>

      {active === "placed" && <ChinaTracking embeddedStage="placed" initialQuery={inboundQuery} />}
      {active === "shipped" && <ChinaTracking embeddedStage="shipped" initialQuery={inboundQuery} />}
      {active === "delivered" && <PendingArrivalSection />}
      {active === "pending_check" && <PendingCheckSection />}
      {active === "checked" && <CheckedSection />}
    </div>
  );
}
